export default {
      id: "into_cloud-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#into_cloud",
      toString: function () {
        return this.url;
      }
    }